import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { VideoBlock } from "@/components/site/VideoBlock";
import { Problem } from "@/components/site/Problem";
import { Results } from "@/components/site/Results";
import { Metrics } from "@/components/site/Metrics";
import { Testimonials } from "@/components/site/Testimonials";
import { Formats } from "@/components/site/Formats";
import { Services } from "@/components/site/Services";
import { Method } from "@/components/site/Method";
import { Markets } from "@/components/site/Markets";
import { About } from "@/components/site/About";
import { Articles } from "@/components/site/Articles";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Newsletter } from "@/components/site/Newsletter";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="bg-white">
      <Toaster position="bottom-right" richColors />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <VideoBlock />
        <Problem />
        <Results />
        <Metrics />
        <Testimonials />
        <Formats />
        <Services />
        <Method />
        <Markets />
        <About />
        <Articles />
        <Contact />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}

export default App;
